import { createAction, props } from '@ngrx/store';

export const FileEditCancel = createAction(
  '[DmsFiles] File Edit Cancel',
);

export const FileEditSave = createAction(
  '[DmsFiles] File Edit Save',
);

export const ResetModalFilesState = createAction(
  '[DmsFiles] Reset Modal Folder Files State',
);

export const SelectFiles = createAction(
  '[DmsFiles] Select Files',
  props<{ ids: string[] }>(),
);

